import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=2a4886d3&"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
